import { AnimatePresence, motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';

import { ContentContext } from 'Components/hooks/context';
import Dateline from 'Components/common/Dateline';

const Status = ({ delay, hasFetched }) => {
  const { common: content } = useContext(ContentContext);

  const [showGenerating, setShowGenerating] = useState(true);

  useEffect(() => {
    if (!hasFetched && !showGenerating) setShowGenerating(true);
  }, [hasFetched, showGenerating]);

  useEffect(() => {
    const timeout = setTimeout(() => setShowGenerating(false), delay);
    return () => clearTimeout(timeout);
  }, [delay, hasFetched]);

  return (
    <div>
      <AnimatePresence key='generating'>
        {showGenerating && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.75 }}
            transition={{ ease: 'easeIn', duration: 0.5 }}
            exit={{ opacity: 0 }}
            className='generating'
          >
            <div className='center'>
              <div className='ring-loader'><div /><div /><div /><div /></div>
              {content.title.generating}
            </div>
          </motion.div>
        )}
        {!showGenerating && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.75 }}
            transition={{ ease: 'easeIn', duration: 0.5, delay: 0.5 }}
            exit={{ opacity: 0 }}
            className='dateline'
          >
            <Dateline />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Status;
